import { FC, ReactNode, useEffect, useState } from "react";
import { Button, ButtonProps } from "../Button/Button";
import { CountdownTimer } from "../CountdownTimer";

export interface ResendCodeButtonProps {
    onResend: () => Promise<void> | void;
    codeSentAt: Date | null;
    cooldownSeconds: number | undefined;
    busy?: boolean;
    resendLabel: ReactNode;
    cooldownLabel: (countdownNode: ReactNode) => ReactNode;
    severity?: ButtonProps["severity"];
    size?: ButtonProps["size"];
    className?: string;
}

export const ResendCodeButton: FC<ResendCodeButtonProps> = (props) => {
    const {
        onResend,
        codeSentAt,
        cooldownSeconds,
        busy,
        resendLabel,
        cooldownLabel,
        severity,
        size,
        className
    } = props;

    const cooldownEndsAt = codeSentAt && cooldownSeconds
        ? new Date(codeSentAt.getTime() + cooldownSeconds * 1000)
        : null;

    const [canResend, setCanResend] = useState(!cooldownEndsAt || new Date() >= cooldownEndsAt);

    useEffect(() => {
        setCanResend(!cooldownEndsAt || new Date() >= cooldownEndsAt);
    }, [cooldownEndsAt?.getTime()]);

    return (
        <Button
            disabled={busy || !canResend}
            isBusy={() => !!busy}
            severity={severity}
            size={size}
            className={className}
            onClick={onResend}
        >
            {canResend
                ? resendLabel
                : cooldownLabel(<CountdownTimer countdownTo={cooldownEndsAt!} onExpiry={() => setCanResend(true)} />)}
        </Button>
    );
};
